import {TrainingStudentTypeDao} from '../../dao';
import {StudentTypeModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateTrainingStudentType(
    userData: Record<string, string>,
    trainingStudentTypeId: number,
    update: Record<string, any>
) {
    try {
        const result = await TrainingStudentTypeDao.updateTrainingStudentType(userData.userToken, trainingStudentTypeId, update);

        const resultParsed = StudentTypeModel.parseStudentTypes(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
